module.exports = __webpack_public_path__ + "img/Payroll-Info.858d0352.svg";